import axios from 'axios';
import {AuthService} from '../auth/authService';

const baseUri = `${process.env.REACT_APP_API_URI}routing/driverTour`;

const getToursForDriver = async () => {
    return await axios.get(`${baseUri}/tours`, {
        params: {
            carrierName: AuthService.getUserOrganization()
        },
        headers: {
            'Content-Type': 'application/json',
            'Authorization': AuthService.getAuthHeader(),
        }
    });
};

const updateProductsOnStops = async (updatedProducts) => {
    return await axios.post(
        `${baseUri}/stops/products`,
        updatedProducts,
        {
            params: {
                carrierName: AuthService.getUserOrganization()
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthService.getAuthHeader(),
            }
        }
    );
};


export const DriverTourService = {
    getToursForDriver,
    updateProductsOnStops
};